import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.DEVELOPER_DARWIN_CONVERSATIONS)({
    component: DarwinConversationsLayout,
    staticData: {
        config: {
            title: "conversations",
            breadcrumb: {
                title: "conversations",
                to: APP_ROUTES_TO.DEVELOPER_DARWIN_CONVERSATIONS,
            },
        },
        permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
    },
});

function DarwinConversationsLayout() {
    return <Outlet />;
}
